// ============================================================================
//  InviteModal.jsx — invite one man by name and email.
//
//  Role and team are decided server-side by the invite-man Edge Function.
// ============================================================================

import React, { useState } from "react";
import { X, Save, Send } from "lucide-react";
import {
  C, display, overlay, sheet, lbl, inp, primaryBtn, iconBtn,
} from "../theme/tokens.js";
import { inviteMan } from "../lib/storage.js";
import { isDemo } from "../demo/demoMode.js";

export default function InviteModal({ callerGroupId, onClose }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setMsg("");
    try {
      await inviteMan({ email: email.trim().toLowerCase(), full_name: name.trim(), group_id: callerGroupId });
      setMsg(isDemo()
        ? "Demo: invite simulated. In the live app he'd get an email with a link to set his password."
        : "Invite sent. He'll get an email with a link to set his password.");
      setEmail(""); setName("");
    } catch (err) {
      setMsg(err.message || "Could not send invite.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div onClick={onClose} style={overlay}>
      <form onClick={(e) => e.stopPropagation()} onSubmit={submit}
        style={{ ...sheet, maxWidth: 460 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ ...display, fontSize: 22, margin: 0, color: C.text }}>Invite a man</h3>
          <button type="button" onClick={onClose} style={iconBtn}><X size={18} /></button>
        </div>
        <p style={{ fontSize: 13, color: C.sub, marginTop: 8 }}>
          Equilibrium Retreat is invite-only. He'll get an email to set his password.
        </p>
        <div style={{ marginTop: 14 }}>
          <label style={lbl}>Full name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} required style={inp} />
        </div>
        <div style={{ marginTop: 14 }}>
          <label style={lbl}>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={inp} />
        </div>
        <button type="submit" disabled={busy}
          style={{ ...primaryBtn, width: "100%", marginTop: 22, opacity: busy ? 0.7 : 1 }}>
          <Save size={16} /> {busy ? "Sending…" : "Send invite"}
        </button>
        {msg && <div style={{ marginTop: 12, fontSize: 13, color: C.sub }}>{msg}</div>}
      </form>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/*  GOAL CARD                                                          */
/* ------------------------------------------------------------------ */
